"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Drawer = exports.Divider = exports.Menu = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var core_1 = require("@material-ui/core");
var Dashboard_1 = __importDefault(require("@material-ui/icons/Dashboard"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var link_1 = __importDefault(require("../../ui/link"));
var drawerWidth = 240;
var useStyles = makeStyles_1["default"](function (theme) {
    var _a;
    return ({
        root: {
            display: 'flex'
        },
        toolbar: {
            paddingRight: theme.spacing(3)
        },
        toolbarIcon: __assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '0 8px' }, theme.mixins.toolbar),
        menuButton: {
            marginRight: theme.spacing(4.5)
        },
        menuButtonHidden: {
            display: 'none'
        },
        drawerPaper: {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            })
        },
        drawerPaperClose: (_a = {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen
                }),
                width: theme.spacing(7)
            },
            _a[theme.breakpoints.up('sm')] = {
                width: theme.spacing(9)
            },
            _a)
    });
});
exports.Menu = function (props) {
    var _a = props.title, title = _a === void 0 ? null : _a, list = props.list, classNames = props.classNames;
    var l = list.map(function (x, i) {
        var Icon = x.Icon ? (react_1["default"].createElement(core_1.ListItemIcon, { className: classNames === null || classNames === void 0 ? void 0 : classNames.icon },
            react_1["default"].createElement(x.Icon, null))) : null;
        return (react_1["default"].createElement(link_1["default"], { key: i, to: x.link },
            react_1["default"].createElement(core_1.ListItem, { button: true, className: classNames === null || classNames === void 0 ? void 0 : classNames.item },
                Icon,
                react_1["default"].createElement(core_1.ListItemText, { secondary: x.label }))));
    });
    return (react_1["default"].createElement(core_1.List, { className: classNames === null || classNames === void 0 ? void 0 : classNames.list },
        react_1["default"].createElement(core_1.ListSubheader, { inset: true }, title),
        l));
};
exports.Divider = core_1.Divider;
exports.Drawer = function (props) {
    var isOpen = props.isOpen, onClose = props.onClose, children = props.children, classNames = props.classNames, hideToggleButton = props.hideToggleButton;
    var classes = useStyles();
    return (react_1["default"].createElement(core_1.Drawer, { variant: "permanent", classes: {
            paper: clsx_1["default"](classes.drawerPaper, !isOpen && classes.drawerPaperClose, classNames === null || classNames === void 0 ? void 0 : classNames.paper)
        }, open: isOpen, className: classNames === null || classNames === void 0 ? void 0 : classNames.drawer },
        hideToggleButton !== true && (react_1["default"].createElement("div", { className: classes.toolbarIcon },
            react_1["default"].createElement(IconButton_1["default"], { onClick: function () { return onClose(); } },
                react_1["default"].createElement(Dashboard_1["default"], null)))),
        children));
};
